import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { HOME, NEWS } from "../../../constants/routes";
import CustomBreadcrumb from "../../moleculas/CustomBreadcrumb";
import ErrorMessage from "../../moleculas/ErrorMessage";
import Loader from "../../moleculas/Loader";
import Paginator from "../../moleculas/Paginator";
import NewsFilters from "../../organims/News/NewsFilters";
import NewsGrid from "../../organims/News/NewsGrid";
import { useNews } from "./useNews";

const News = () => {
  const { t } = useTranslation("news");
  const {
    loading,
    error,
    noticias,
    page,
    totalPages,
    query,
    category,
    categories,
    hasFilters,
    onPageChange,
    onQueryChange,
    onCategoryChange,
    onClear,
    retry,
  } = useNews();

  useEffect(() => {
    document.title = `SINIA - ${t("title")}`;
  }, [t]);

  return (
    <div className="w-100 d-flex justify-content-md-start justify-content-lg-start flex-column">
      <div className="w-100">
        <div className="d-flex flex-column align-items-center justify-content-start">
          <div className="custom-blue-background"></div>
          <div className="custom-yellow-background"></div>
        </div>
      </div>
      <div className="w-100 d-flex flex-column align-items-center page-header-custom">
        <div className="w-75 align-items-left">
          <CustomBreadcrumb
            isWhite={true}
            breadcrumbs={[
              { name: t("home"), href: HOME },
              { name: t("title"), href: NEWS },
            ]}
          />
        </div>
        <div className="d-flex w-75 mb-2 align-items-left">
          <div className="col-lg-6 col-12">
            <h1>{t("title")}</h1>
            <p>{t("description")}</p>
          </div>
        </div>
      </div>

      <div className="w-100 my-5 d-flex flex-column align-items-center">
        <div className="w-75 d-flex flex-column align-items-center gap-4">
          <NewsFilters
            query={query}
            category={category}
            categories={categories}
            onQueryChange={onQueryChange}
            onCategoryChange={onCategoryChange}
            onClear={onClear}
          />

          {loading ? <Loader /> : null}

          {!loading && error ? (
            <div className="d-flex flex-column align-items-center gap-3">
              <ErrorMessage message={error} />
              <Button onClick={retry} className="custom-primary-button">
                {t("retry")}
              </Button>
            </div>
          ) : null}

          {!loading && !error && noticias.length === 0 ? (
            <ErrorMessage
              message={hasFilters ? t("emptyFiltered") : t("empty")}
            />
          ) : null}

          {!loading && !error && noticias.length > 0 ? (
            <>
              <NewsGrid noticias={noticias} />
              <Paginator
                currentPage={page}
                onPageChange={onPageChange}
                totalPages={totalPages}
              />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default News;
